import React, { Component } from 'react';

class Education extends Component {
  
  render() {
    const education = (
    <section id="education" className="resume-section">
    <article className="container">
    <div className="row">
        <div className="category-title col-md-12">
        <div className="row">
            <div className="col-md-4">
            <h2>Education</h2>
            </div>
        </div>
        </div>
        <div className="card-container">
        <span className="col-md-3 col-md-offset-1 side-note">August 2007 – May 2011</span>
        <div className="col-md-6 resume-card">
            <h3 className="title">University of Technology<small>Bachelor of Science in Computer Science</small></h3>
            <p>Four-year degree in Computing and Information Technology, Major: Enterprise Computing.
            </p>
            <h3 className="title"><small>Major Project</small></h3>
        </div>
        </div>
    </div>
    </article>
    </section>
    );
    return (
         education
    );
  }
  
}

export default Education;



// WEBPACK FOOTER //
// ./src/components/resume-components/education.js